'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _spinnerLocal = require('./spinner.local.css');

var _spinnerLocal2 = _interopRequireDefault(_spinnerLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable no-plusplus */


var renderBars = function renderBars(color) {
  var bars = [];

  for (var i = 0; i < 12; i++) {
    var barStyle = {}; // eslint-disable-next-line no-multi-assign

    barStyle.WebkitAnimationDelay = barStyle.animationDelay = (i - 12) / 10 + 's'; // eslint-disable-next-line no-multi-assign

    barStyle.WebkitTransform = barStyle.transform = 'rotate(' + i * 30 + 'deg) translate(146%)';
    bars.push(_react2.default.createElement('div', {
      style: barStyle,
      className: (0, _classnames2.default)(_spinnerLocal2.default.spinnerBar, _spinnerLocal2.default[color]),
      key: i
    }));
  }

  return bars;
};

var Spinner = function Spinner(props) {
  var classes = [_spinnerLocal2.default.base, _spinnerLocal2.default[props.size], props.className];
  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)(classes, _spinnerLocal2.default.spinner)
  }, renderBars(props.color));
};

Spinner.defaultProps = {
  color: 'primary',
  size: 'large'
};
Spinner.propTypes = {
  /**
   * 'primary', 'white', 'midgray', 'currentColor',
   */
  color: _propTypes2.default.oneOf(['primary', 'white', 'midgray', 'currentColor']),

  /**
   * 'small', 'medium', 'large'
   */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),

  /**
   * ClassName will insert styles to override defaults
   */
  className: _propTypes2.default.string
};
exports.default = Spinner;